// removed by extract-text-webpack-plugin
module.exports = {"badge":"DynamicContentBadge-module__badge___1JCxj","icon":"DynamicContentBadge-module__icon___oPWlc"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/DynamicContentBadge.module.scss
// module id = 275
// module chunks = 0 1